// extracted by mini-css-extract-plugin
export var copyable = "_b-1";
export var explainable = "_b-0";
export var negative = "_b-2";
export var positive = "_b-3";